import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFaceId: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFaceId"><Path d="M12.5 8V11C12.5 12.1046 11.6046 13 10.5 13" stroke="currentColor"/><Path d="M8.5 3.5H3.5V8.5M3.5 15.5V20.5H8.5M15.5 3.5H20.5V8.5M20.5 15.5V20.5H15.5M8 8.5V10M16 8.5V10M9 15.6973C9.88252 16.2078 10.9071 16.5 12 16.5C13.0929 16.5 14.1175 16.2078 15 15.6973" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFaceId;
